import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import React from 'react';
import { DeepPartial } from 'react-hook-form';
import { FormModel } from './form';

export type IVacancyCreationFormInitialValues = Omit<DeepPartial<FormModel>, 'city'>;

export interface IVacancyCreateOrEditContext {
  create: (initialValues?: Partial<IVacancyCreationFormInitialValues>) => void;
  edit: (id: ApiServerEntityIDType) => void;
}

export const VacancyCreateOrEditContext = React.createContext<IVacancyCreateOrEditContext>({
  create: () => {
    throw new Error('Vacancy create or edit context is not provided');
  },
  edit: () => {
    throw new Error('Vacancy create or edit context is not provided');
  },
});
